<template>
  <div>
    <div :class="typeClass">
      <v-row class="align-center">
        <v-col cols="18"
          >{{ notification.message }}
          <div v-if="hasError && !isDjangoError" class="text-body-2">
            [{{ notification.errorBody.Error }}]
          </div>
        </v-col>

        <v-btn text @click.stop="closeNotification(notification)"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-row
      >

      <div v-if="isDjangoError">
        <v-dialog v-model="dialog" fullscreen>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small color="red lighten-2" dark v-bind="attrs" v-on="on">
              View Error
            </v-btn>
          </template>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <iframe
              :srcdoc="notification.errorBody"
              height="2500"
              width="2500"
              frameborder="0"
            ></iframe>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    notification: Object
  },
  computed: {
    typeClass() {
      return `alert ${this.notification.type}`;
    },
    isDjangoError() {
      return this.hasError && typeof this.notification.errorBody !== "object";
    },
    hasError() {
      return !!this.notification.errorBody;
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    ...mapActions(["removeNotification"]),
    closeNotification(notification) {
      this.removeNotification(notification);
    }
  }
};
</script>

<style scoped lang="scss">
.notifications-list .alert {
  padding: 15px;
  opacity: 1;
  transition: opacity 0.6s;
  margin-bottom: 15px;
  border-radius: 12px;
  &.success {
    border: 2px solid #4caf50;
    background-color: #4caf505d !important;
  }
  &.infoMessage {
    border: 2px solid #2196f3;
    background-color: #2196f35d;
  }
  &.warning {
    border: 2px solid #ff9900;
    background-color: #ff99005d !important;
  }
  &.errorMessage {
    border: 2px solid red;
    background-color: rgba(255, 0, 0, 0.1);
  }
}
.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}
.closebtn:hover {
  color: black;
}
</style>
